import { forwardRef, useId } from "react";
import SystemIcon from "./SystemIcon";

const CHECKBOX_SIZE_ALIASES = {
  md: "medium",
  lg: "large",
};

const CHIP_SIZE_ALIASES = {
  sm: "small",
  md: "medium",
  lg: "large",
};

function normalizeSize(size, aliases) {
  return aliases[size] || size;
}

export const Checkbox = forwardRef(function Checkbox({
  id,
  label,
  description,
  size = "medium",
  className = "",
  children,
  ...props
}, ref) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const normalizedSize = normalizeSize(size, CHECKBOX_SIZE_ALIASES);
  const content = children ?? label;

  return (
    <div className={`ds-checkbox ds-checkbox--${normalizedSize}${className ? ` ${className}` : ""}`}>
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        className="ds-checkbox__input"
        {...props}
      />
      <label className="ds-checkbox__label" htmlFor={inputId}>
        <span className="ds-checkbox__control" aria-hidden="true">
          <SystemIcon name="check-active" size="xsmall" />
        </span>
        <span className="ds-checkbox__text">{content}</span>
      </label>
      {description ? <p className="ds-checkbox__description">{description}</p> : null}
    </div>
  );
});

export const CheckboxChip = forwardRef(function CheckboxChip({
  id,
  size = "medium",
  className = "",
  children,
  ...props
}, ref) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const normalizedSize = normalizeSize(size, CHIP_SIZE_ALIASES);

  return (
    <span className={`ds-checkbox-chip ds-checkbox-chip--${normalizedSize}${className ? ` ${className}` : ""}`}>
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        className="ds-checkbox-chip__input"
        {...props}
      />
      <label className="ds-checkbox-chip__label" htmlFor={inputId}>
        <SystemIcon name="check" size="xsmall" className="ds-checkbox-chip__icon ds-checkbox-chip__icon--idle" />
        <SystemIcon name="check-active" size="xsmall" className="ds-checkbox-chip__icon ds-checkbox-chip__icon--checked" />
        <span>{children}</span>
      </label>
    </span>
  );
});
